import { Button, Grid, Typography } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons'
import numeral from 'numeral'
import { themeNew } from 'styles/theme-new'
import { ExceptionType, NewValue } from '../../restrictions.types'
function Exception({
  exception,
  handleRestore,
}: {
  exception: ExceptionType
  handleRestore: (exception: ExceptionType) => void
}) {
  const { currValue, defaultValue, label } = exception

  const renderValue = (value: NewValue) => {
    switch (typeof value) {
      case 'string':
        return value
      case 'number':
        return numeral(value).format('0,0')
      case 'boolean':
        return value ? 'Yes' : 'No'
      case 'object':
        if (value === null) {
          return 'No value'
        }
        // Handle BeneficialOwnersType object
        if ('enabled' in value && 'default_legitimate_reason' in value) {
          const enabled = value.enabled ? 'Enabled' : 'Disabled'
          const reason = value.default_legitimate_reason || 'None'
          return `${enabled} (${reason})`
        }
        // Handle arrays: an empty list (no score models, no countries) reads
        // as "None" rather than a blank cell (ENG2-2455).
        if (Array.isArray(value)) {
          if (value.length === 0) return 'None'
          // @ts-ignore
          if (value?.[0]?.model) {
            return value.map((x: { model: string }) => x.model).join(', ')
          }
          return value.join(', ')
        }
        return JSON.stringify(value)
      case 'undefined':
        return 'No value'
      default:
        return ''
    }
  }

  return (
    <>
      <Grid item xs={3}>
        <Typography>{label}</Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="h5">{renderValue(currValue)}</Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="h5"> {renderValue(defaultValue)}</Typography>
      </Grid>
      <Grid item xs={3}>
        <ThemeProvider theme={themeNew}>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => handleRestore(exception)}
            startIcon={<FontAwesomeIcon icon={faRotateLeft} />}
          >
            Restore
          </Button>
        </ThemeProvider>
      </Grid>
    </>
  )
}

export default Exception
